var _g, _defs;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
class IconAiColoredSolid extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsxs(SVGIcon, {
      ...this.props,
      name: "IconAiColored",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: [_g || (_g = _jsxs("g", {
        clipPath: "url(#clip0_11521_4097)",
        children: [_jsx("path", {
          d: "M960 0L1219.29 700.713L1920 960L1219.29 1219.29L960 1920L700.713 1219.29L0 960L700.713 700.713L960 0Z",
          fill: "url(#paint0_linear_11521_4097)"
        }), _jsx("path", {
          d: "M1600 0L1686.43 233.571L1920 320L1686.43 406.429L1600 640L1513.57 406.429L1280 320L1513.57 233.571L1600 0Z",
          fill: "url(#paint1_linear_11521_4097)"
        })]
      })), _defs || (_defs = _jsxs("defs", {
        children: [_jsxs("linearGradient", {
          id: "paint0_linear_11521_4097",
          x1: "-476.25",
          y1: "-392.727",
          x2: "-7.61685",
          y2: "3078.25",
          gradientUnits: "userSpaceOnUse",
          children: [_jsx("stop", {
            stopColor: "#9E58BD"
          }), _jsx("stop", {
            offset: "1",
            stopColor: "#00828E"
          })]
        }), _jsxs("linearGradient", {
          id: "paint1_linear_11521_4097",
          x1: "1121.25",
          y1: "-130.909",
          x2: "1277.46",
          y2: "1026.08",
          gradientUnits: "userSpaceOnUse",
          children: [_jsx("stop", {
            stopColor: "#9E58BD"
          }), _jsx("stop", {
            offset: "1",
            stopColor: "#00828E"
          })]
        }), _jsx("clipPath", {
          id: "clip0_11521_4097",
          children: _jsx("rect", {
            width: "1920",
            height: "1920",
            fill: "white"
          })
        })]
      }))]
    });
  }
}
IconAiColoredSolid.glyphName = 'ai-colored';
IconAiColoredSolid.variant = 'Solid';
IconAiColoredSolid.displayName = 'IconAiColoredSolid';
IconAiColoredSolid.allowedProps = [...SVGIcon.allowedProps];
export default IconAiColoredSolid;
export { IconAiColoredSolid };